import Vue from 'vue'
import App from './App.vue'
import router from './router'
// VueLeaflet style.
import 'leaflet/dist/leaflet.css'
// Global styles
import 'bootstrap-css-only'
import './assets/style/app.scss'
import './assets/style/font.scss'
import store from './store'
import VueNativeSock from 'vue-native-websocket'
import Vue2TouchEvents from 'vue2-touch-events'
import { WS_ADDRESS } from './config'

export const eventBus = new Vue()

Vue.use(
    VueNativeSock,
    WS_ADDRESS,
    {
        connectManually: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 3000,
    },
    { store: store, parse: 'json' }
)
Vue.use(Vue2TouchEvents)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
